const Backdrop = ({ onClick }: BackdropInterface) => {
  return (
    <>
      <div
        onClick={onClick}
        className='fixed w-full h-full left-0 right-0 top-0 z-40 backdrop-blur-sm'
      ></div>
    </>
  )
}

export default Backdrop
